/**
 * DevExtreme (esm/ui/tab_panel.js)
 * Version: 24.1.8
 * Build date: Mon Dec 16 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import TabPanel from "../__internal/ui/tab_panel/m_tab_panel";
export default TabPanel;
